import { FaEye, FaHistory } from "react-icons/fa";
import "../../../../Assets/Styles/App/UI/ReadOnly/ReadOnly.css";

const formatDateTime = (value) => {
    if (!value) return "Sin dato";

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "Sin dato";

    return date.toLocaleString("es-AR", {
        dateStyle: "medium",
        timeStyle: "short",
    });
};

export const ReadOnlyInfo = ({
    createdAt = null,
    updatedAt = null,
    heading = "Registro",
    createdLabel = "Creado",
    updatedLabel = "Actualizado",
    note = "Este modal es solo lectura. Para cambiar algo, cerrá y usá el lápiz del registro.",
}) => (
    <div className="LStudio__readonly_info">
        <div className="LStudio__readonly_info_heading">
            <FaHistory />
            <strong>{heading}</strong>
        </div>

        <div className="LStudio__readonly_info_dates">
            <div>
                <span>{createdLabel}</span>
                <b>{formatDateTime(createdAt)}</b>
            </div>
            <div>
                <span>{updatedLabel}</span>
                <b>{formatDateTime(updatedAt)}</b>
            </div>
        </div>

        <div className="LStudio__readonly_info_note">
            <FaEye />
            <p>{note}</p>
        </div>
    </div>
);
